// Hands a make that's a message (an email, letter, invitation...) to the user's
// email app, with its subject line as the email's subject.

const MESSAGE =
  /\b(e-?mails?|letters?|messages?|notes?|invitations?|invites?|replies|reply|responses?|thank[- ]?you|complaints?|apology|apologies|announcements?|newsletters?|cover letter|resignation|follow[- ]?up|introduction)\b/i;
const OPENING = /^\s*(\**subject\**\s*:|dear\b|hi\b|hello\b|hey\b|to whom)/im;

// Most email apps cut off longer mailto links
const MAX_LINK = 1800;

export function looksLikeMessage(prompt = "", text = "", output = "") {
  if (!["text", "docx", "pdf"].includes(output)) return false;
  return MESSAGE.test(prompt) || OPENING.test(text.slice(0, 400));
}

// { subject, body }: a "Subject:" line at the top becomes the subject
export function emailParts(text = "", title = "") {
  const match = /^\s*\**subject\**\s*:\s*\**\s*(.+?)\s*\**\s*$/im.exec(
    text.split("\n").slice(0, 3).join("\n")
  );
  if (match) {
    return {
      subject: match[1].trim(),
      body: text.replace(match[0], "").replace(/^\s+/, ""),
    };
  }
  return { subject: title.trim(), body: text.trim() };
}

// { url, complete }: when the text is too long for a link, only the subject goes
// in it and the body has to be pasted
export function mailtoLink({ subject, body }) {
  const query = (fields) =>
    Object.entries(fields)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");
  const full = `mailto:?${query({ subject, body })}`;
  if (full.length <= MAX_LINK) {
    return { url: full, complete: true };
  }
  return { url: `mailto:?${query({ subject })}`, complete: false };
}
